// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"part-checkbox_checkbox__8T2fQ","label":"part-checkbox_label__GtV53"};